import { render, staticRenderFns } from "./CryptoPageRedirect.vue?vue&type=template&id=cbefd2b0"
import script from "./CryptoPageRedirect.vue?vue&type=script&lang=js"
export * from "./CryptoPageRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports